import { useEffect, useRef } from 'react';

const CHECK_INTERVAL = 60_000; // 60s

export const useVersionCheck = () => {
  const knownVersion = useRef(null);
  const needsReload = useRef(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const { v } = await res.json();
        if (!knownVersion.current) {
          knownVersion.current = v;
        } else if (v !== knownVersion.current) {
          needsReload.current = true;
        }
      } catch {
        // network error — skip
      }
    };

    checkVersion();
    const id = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(id);
  }, []);

  return needsReload;
};
